import { REPORT_MARKETING_CONSENTS } from './types';

export const reportMarketingConsents = marketingConsents => ({
  type: REPORT_MARKETING_CONSENTS,
  marketingConsents,
});
